export class Parametros {
  public nomeBancoBpo!: string;
  public urlBpo!: string;
  public usuarioBpo!: string;
  public senhaBpo!: string;
  public urlDigitalBpo!: string;
  public urlLecca!: string;
  public tokenLecca!: string;
  public urlVortx!: string;
  public tokenVortx!: string;
  public urlCessao!: string;
  public tokenCessao!: string;
  public integraS3!: boolean;
  public accessKeyS3!: string;
  public secretKeyS3!: string;
  public bucketS3!: string;
  public pastaDocumentosS3!: string;
  public pastaComunicadosS3!: string;
  public localizacaoS3!: string;
  public backoffice!: string;
  public processadoraCartao!: string;
  public usuarioFuncao!: string;
  public codMeioPagamento!: string;
  public idOriginador!: number ;
  public chaveApiPh3a!: string;
  public serviceAccountIss!: string;
  public urlDeAutenticacao!: string;
  public urlApi!: string;
  public login_cpf!: number;


}